import React from 'react';
import { faBorderOuter, faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactTooltip from 'react-tooltip';
import ToolBarColorPicker from 'components/actionBar/components/ToolbarColorPicker';
import Switch from 'components/common/Switch';
import c from '../CalendarGrid.module.scss';
import SettingsSection from '../SettingsSection';

/** @type {{field: 'borderTop'|'borderRight'|'borderBottom'|'borderLeft', side: string, label: string}[]} */
const borderOptions = [
  { field: 'borderTop', side: 'top', label: 'Top border' },
  { field: 'borderRight', side: 'right', label: 'Right border' },
  { field: 'borderBottom', side: 'bottom', label: 'Bottom border' },
  { field: 'borderLeft', side: 'left', label: 'Left border' },
];

/**
 * @param {Object} props
 * @param {import('actions/scene.types').CalendarShape} props.calendar Calendar shape being edited.
 * @param {import('actions/scene.types').CalendarShapeChangeHandler} props.onChange Applies a partial calendar update.
 * @returns {React.ReactElement}
 */
const DayBordersSection = ({ calendar, onChange }) => {
  return (
    <SettingsSection title="Day borders">
      {borderOptions.map(({ field, side, label }) => (
        <div key={field}>
          <Switch
            id={`calendar-day-${side}-border`}
            className={c.debugSwitch}
            checked={calendar[field] === true}
            onChange={() => onChange({ [field]: !calendar[field] })}
            label={label}
            aria-label={`Show day-cell ${side} border`}
          />
        </div>
      ))}
      <div className={c.generalField}>
        <div className={c.fieldLabel}>Border colour</div>
        <div className={c.colourControl}>
          <ToolBarColorPicker
            initialValue={calendar.borderColor || calendar.mainColor}
            onChange={(borderColor) => onChange({ borderColor })}
            icon={faBorderOuter}
            alignPickerLeft
          />
        </div>
      </div>
      <div className={c.generalField}>
        <div className={c.fieldLabel}>
          Adjacent month colour
          <button
            type="button"
            className={c.infoButton}
            aria-label="About adjacent month colour"
            data-for="calendarAdjacentMonthBorderTooltip"
            data-tip="Sets the border colour for day cells outside the current month."
          >
            <FontAwesomeIcon.Memo icon={faCircleInfo} />
          </button>
          <ReactTooltip id="calendarAdjacentMonthBorderTooltip" place="right" type="dark" effect="solid" />
        </div>
        <div className={c.colourControl}>
          <ToolBarColorPicker
            initialValue={calendar.secondaryColor}
            onChange={(secondaryColor) => onChange({ secondaryColor })}
            icon={faBorderOuter}
            alignPickerLeft
          />
        </div>
      </div>
    </SettingsSection>
  );
};

export default DayBordersSection;
